// PERSISTED

// NON PERSISTED

export const getUpdateAvailable = (state) => {
  return state.VNUpdateManager.get('updateAvailable')
}

export const getShouldUpdate = (state) => {
  return state.VNUpdateManager.get('shouldUpdate')
}

export const getShouldShowUpdateModal = (state) => {
  return state.VNUpdateManager.get('shouldShowUpdateModal')
}
